import { ANIMATION_DURATION } from './constants';

export default (theme) => ({
    container: {
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        overflow: 'hidden',
        position: 'relative',
        width: '100%',
        '&::before, &::after': {
            content: '""',
            position: 'absolute',
            display: 'block',
            left: 0,
            height: 10,
            width: '100%',
            zIndex: 1,
        },
        '&::before': {
            top: -5,
            background:
                'linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))',
        },
        '&::after': {
            bottom: -5,
            background: 'linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))',
        },
    },
    phrase: {
        ...theme.typography.caption,
        alignItems: 'center',
        color: theme.colors.textLight.primary,
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        left: 0,
        opacity: 1,
        overflow: 'hidden',
        position: 'absolute',
        right: 0,
        textAlign: 'center',
        transition: `transform ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1)`,
        whiteSpace: 'nowrap',
        zIndex: 0,
    },
    phraseDone: {
        color: theme.colors.textLight.jadeAccessible,
    },
    phraseTop: {
        top: 0,
        transform: 'translateY(-100%)',
    },
    phraseCenter: {
        top: '50%',
        transform: 'translateY(-50%)',
    },
    phraseBottom: {
        top: '100%',
        transform: 'translateY(0)',
    },
    phraseEmpty: {
        opacity: '0 !important',
        pointerEvents: 'none',
    },
});
